import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page.component';
import { ActivatedRoute, Router, Params } from '@angular/router';

import { ConfirmComponent } from '../../modal/confirm.component';
import { ActionPlanService, LanguageService } from '../../shared/services/index';
import { ActionPlanModel, ActionPlanGroupedItemsModel } from '../../shared/models/index';
import { ModalComponent } from '../../modal/modal.component';
import { ApplicationType, SelectorComponent } from '../../utils';
import { InputLangComponent } from '../../modal/inputlang.component';
import { ActionPlanDetailMenu, ActionPlanMenuComponent } from '../../menus/action-plan.menu';

@Component({
    templateUrl: './detail.component.html',
    standalone: false
})
export class ActionPlanDetailPageComponent extends BasePageComponent implements OnInit {
  public actionPlan: ActionPlanModel;
  public actionPlanId: string;
  public loading = false;
  languages: any[];
  @ViewChild('doneConfirm', { static: true }) doneConfirm: ConfirmComponent;
  @ViewChild('reportLangModal', { static: true }) reportLangModal: ModalComponent;
  @ViewChild('languagesModal', { static: true }) languageModal: InputLangComponent;

  public appType = 1;
  public i18nPrefix = 'actionplans.optimisation';

  constructor(
    public actionPlanService: ActionPlanService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private language: LanguageService
  ) {
    super(location);
  }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['actionPlanId'];
      if (id == null) {
        this.router.navigate([this.inspectionsRoute]);
      }

      this.actionPlanId = id;
      this.actionPlanService.getActionPlan(this.actionPlanId).subscribe((data) => {
        this.actionPlan = data;
        if (
          this.actionPlan &&
          this.actionPlan.hasOwnProperty('applicationType') &&
          this.actionPlan.applicationType === ApplicationType.Maintenance
        ) {
          this.appType = ApplicationType.Maintenance;
          this.i18nPrefix = 'actionplans.maintenance';
        } else {
          this.appType = ApplicationType.Optimization;
          this.i18nPrefix = 'actionplans.optimisation';
        }
        this.loading = false;
      });
      this.language.getLanguages().subscribe((data) => {
        this.languages = data;
      });
    });
  }

  public openResponsible(item: ActionPlanGroupedItemsModel) {
    this.router.navigate([this.actionPlansRoute, this.actionPlanId, 'responsible', item.side]);
  }

  public openMenu(): void {
    this.modal.modalFooter = false;
    this.modal.modalHeader = false;
    this.modal.modalMessage = false;
    this.modal.open(ActionPlanMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case ActionPlanDetailMenu.Done:
        this.openDoneConfirm();
        break;
      case ActionPlanDetailMenu.Collaborate:
        this.gotoCollaborate();
        break;
      case ActionPlanDetailMenu.CreateReport:
        this.downloadReport();
        break;
      case ActionPlanDetailMenu.Reports:
        this.gotoReportList();
        break;
      case ActionPlanDetailMenu.Inspection:
        this.openInspection();
        break;
      case ActionPlanDetailMenu.ChangeInputLanguage:
        this.openLanguagesSelector();
        break;
      default:
    }
  }

  public openLanguagesSelector(): void {
    const languageIndex = this.languages.findIndex((l) => l === this.actionPlan.inputLanguage);
    this.languageModal.modalFooter = true;
    this.languageModal.modalHeader = true;
    this.languageModal.modalMessage = true;
    this.languageModal.open({
      values: this.languages,
      selectedIndex: languageIndex
    });
  }

  public selectLanguagesMenu($event): void {
    if (this.actionPlan.inputLanguage !== $event) {
      this.actionPlanService.changeInputLanguage(this.actionPlanId, $event).subscribe((r) => {
        if (r) {
          location.reload();
        }
      });
    }
  }

  public openInspection(): void {
    this.router.navigate([this.inspectionsRoute, this.actionPlan.inspection.id]);
  }

  private downloadReport(): void {
    const languageIndex = this.languages.findIndex((l) => l === this.actionPlan.inputLanguage);
    this.reportLangModal.modalFooter = false;
    this.reportLangModal.modalHeader = false;
    this.reportLangModal.modalMessage = false;
    this.reportLangModal.open(SelectorComponent, {
      values: this.languages.map((v) => v.toUpperCase()),
      selectedIndex: languageIndex
    });
  }

  public createReport(item: any) {
    this.actionPlanService.createReport(this.actionPlanId, item.value.toLowerCase()).subscribe(() => {
      this.gotoReportList();
    });
  }

  public gotoReportList() {
    return this.router.navigate([this.actionPlansRoute, this.actionPlanId, 'reports']);
  }

  public gotoCollaborate() {
    return this.router.navigate([this.actionPlansRoute, this.actionPlanId, 'collaborate']);
  }

  goToBack(): void {
    this.router.navigate([this.actionPlansRoute]);
  }

  openDoneConfirm() {
    this.doneConfirm.open();
  }

  markAsDone(e: any) {
    this.actionPlanService.updateActionPlanStatus(this.actionPlanId, 100).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
